import React, { useState } from 'react';
import api from '../api';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showRecuperar, setShowRecuperar] = useState(false);
  const [emailRec, setEmailRec] = useState('');
  const [msgRec, setMsgRec] = useState('');
  const [loadingRec, setLoadingRec] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      // Pegar la matriz de permisos dentro del usuario, para el menú dinámico
      const usuarioConPermisos = { ...res.data.usuario, permisos: res.data.permisos };
      localStorage.setItem('combustible_token', res.data.access_token);
      localStorage.setItem('combustible_usuario', JSON.stringify(usuarioConPermisos));
      onLogin(usuarioConPermisos);
    } catch {
      setError('Credenciales incorrectas. Verifique su email y contraseña.');
    } finally {
      setLoading(false);
    }
  };

  const handleRecuperar = async (e) => {
    e.preventDefault();
    setMsgRec(''); setLoadingRec(true);
    try {
      const res = await api.post('/auth/recuperar', { email: emailRec });
      setMsgRec(res.data.mensaje || 'Si el correo está registrado, recibirás una contraseña temporal.');
    } catch {
      setMsgRec('Ocurrió un error. Intenta de nuevo o contacta al administrador.');
    } finally {
      setLoadingRec(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Logo real GR */}
        <div style={styles.logoArea}>
          <img
            src="/logo-gr.png"
            alt="Estación de Servicios Gerónimo Ramírez SRL"
            style={styles.logoImg}
          />
          <h1 style={styles.appName}>CombustibleApp</h1>
          <p style={styles.appSub}>ESTACIÓN DE SERVICIOS GERÓNIMO RAMÍREZ SRL</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}

          <div style={styles.group}>
            <label style={styles.label}>Correo electrónico</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="usuario@empresa.com"
              required
            />
          </div>

          <div style={styles.group}>
            <label style={styles.label}>Contraseña</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ ...styles.input, paddingRight: '44px' }}
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', padding: 0, lineHeight: 1 }}
                tabIndex={-1}
                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <button type="submit" style={styles.btn} disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>

          <button type="button" onClick={() => { setShowRecuperar(true); setMsgRec(''); setEmailRec(''); }} style={styles.forgotLink}>
            ¿Olvidaste tu contraseña?
          </button>
        </form>

        {showRecuperar && (
          <div style={styles.modalOverlay} onClick={() => setShowRecuperar(false)}>
            <div style={styles.modal} onClick={e => e.stopPropagation()}>
              <h3 style={styles.modalTitle}>Recuperar contraseña</h3>
              <p style={styles.modalText}>Ingresa tu correo y te enviaremos una contraseña temporal.</p>
              {msgRec ? (
                <div style={styles.msgOk}>{msgRec}</div>
              ) : (
                <form onSubmit={handleRecuperar} style={styles.form}>
                  <input
                    type="email"
                    value={emailRec}
                    onChange={e => setEmailRec(e.target.value)}
                    style={styles.input}
                    placeholder="tu@correo.com"
                    required
                  />
                  <button type="submit" style={styles.btn} disabled={loadingRec}>
                    {loadingRec ? 'Enviando...' : 'Enviar contraseña temporal'}
                  </button>
                </form>
              )}
              <button type="button" onClick={() => setShowRecuperar(false)} style={styles.modalClose}>
                Cerrar
              </button>
            </div>
          </div>
        )}

        <p style={styles.footer}>
          © 2026 Global Business Consulting · Todos los derechos reservados
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d0000 50%, #1a1a1a 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: '#fff',
    borderRadius: '16px',
    padding: '40px 36px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
  },
  logoArea: {
    textAlign: 'center',
    marginBottom: '32px',
  },
  logoImg: {
    width: '100px',
    height: '100px',
    objectFit: 'contain',
    margin: '0 auto 12px',
    display: 'block',
  },
  appName: {
    color: '#1a1a1a',
    fontSize: '24px',
    fontWeight: '800',
    margin: '0 0 4px',
    letterSpacing: '-0.5px',
  },
  appSub: {
    color: '#CC0000',
    fontSize: '11px',
    fontWeight: '700',
    margin: 0,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#1a1a1a',
  },
  input: {
    padding: '12px 14px',
    borderRadius: '8px',
    border: '1.5px solid #e0e0e0',
    fontSize: '14px',
    outline: 'none',
    color: '#1a1a1a',
  },
  error: {
    background: '#fff0f0',
    border: '1px solid #ffcccc',
    color: '#CC0000',
    padding: '10px 14px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '500',
  },
  btn: {
    background: 'linear-gradient(135deg, #CC0000, #990000)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '14px',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    marginTop: '8px',
    letterSpacing: '0.3px',
    boxShadow: '0 4px 12px rgba(204,0,0,0.3)',
  },
  footer: {
    textAlign: 'center',
    color: '#999',
    fontSize: '11px',
    marginTop: '24px',
    marginBottom: 0,
  },
  forgotLink: {
    background: 'none', border: 'none', color: '#CC0000', fontSize: '13px',
    fontWeight: '600', cursor: 'pointer', marginTop: '4px', padding: '4px',
  },
  modalOverlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px',
  },
  modal: {
    background: '#fff', borderRadius: '14px', padding: '28px 24px', maxWidth: '380px', width: '100%',
  },
  modalTitle: { fontSize: '18px', fontWeight: '800', color: '#1a1a1a', margin: '0 0 8px' },
  modalText: { fontSize: '13px', color: '#666', margin: '0 0 18px' },
  msgOk: {
    background: '#f0fff4', border: '1px solid #c6f6d5', color: '#22543d',
    padding: '14px', borderRadius: '8px', fontSize: '13px', textAlign: 'center',
  },
  modalClose: {
    background: 'none', border: 'none', color: '#999', fontSize: '13px',
    cursor: 'pointer', marginTop: '16px', width: '100%', padding: '8px',
  },
};

export default Login;
